import React from 'react';
import '../styles/theme.css';
import '../styles/Leads.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import LeadsOpener from '../components/LeadsOpener';
import LeadsTable from '../components/LeadsTable';
/* IMPORTS */

function LeadsPage() {
  return (
    <div className="le-root">
      <div className="le-layout-1">
        <div id="leadsnavbar" className="le-slot-leadsnavbar">
          <Navbar activePage={"Leads"} />
        </div>
        <div className="le-layout-2">
          <div id="leadsopener" className="le-slot-leadsopener">
            <LeadsOpener />
          </div>
          <div id="leadstable" className="le-slot-leadstable">
            <LeadsTable />
          </div>
        </div>
        <div id="leadsfooter" className="le-slot-leadsfooter">
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default LeadsPage;
